module.exports = __webpack_public_path__ + "static/buildup_about2-429b888a4b3aec8bdd03ab28f737a7c3.png";